import React from 'react';
import IconFlag from 'src/pages/components/utilities/IconFlag';
var selfStyles = require('./styles.scss');
var ListAthleteItemFlag = function (props) { return (props.countryCode || props.countryState
    ? (React.createElement("span", { className: selfStyles.athleteCountry },
        props.countryCode && React.createElement(IconFlag, { code: props.countryCode.toLowerCase() }),
        props.countryCode && props.countryState && ' ',
        props.countryState && props.countryState))
    : null); };
export default ListAthleteItemFlag;



//////////////////
// WEBPACK FOOTER
// ./src/imports/components/Scoreboard/components/ListAthletesItemFlag.tsx
// module id = 688
// module chunks = 0